document.addEventListener('DOMContentLoaded', () => {
  const stickyBars = document.querySelectorAll('.sticky-add-to-cart');
  if (!stickyBars.length) return;

  const setupStickyBar = (bar) => {
    const sectionId = bar.dataset.sectionId;
    if (!sectionId) return;

    const mainAddButton = document.querySelector(`#ProductSubmitButton-${sectionId}`);
    if (!mainAddButton) return;

    const mainAddButtonText = mainAddButton.querySelector('span');
    const mainQuantity = document.querySelector(`#Quantity-${sectionId}`);
    const productForm = document.getElementById(bar.dataset.productFormId);
    const stickyButton = bar.querySelector('[data-sticky-submit]');
    const stickyButtonText = stickyButton ? stickyButton.querySelector('span') : null;
    const stickyQuantity = bar.querySelector('[data-sticky-quantity]');

    const syncButton = () => {
      if (!stickyButton) return;
      const disabled = mainAddButton.hasAttribute('disabled');
      if (disabled) {
        stickyButton.setAttribute('disabled', 'disabled');
      } else {
        stickyButton.removeAttribute('disabled');
      }
      if (mainAddButtonText && stickyButtonText) {
        stickyButtonText.textContent = mainAddButtonText.textContent;
      }
    };

    const syncQuantityAttributes = () => {
      if (!mainQuantity || !stickyQuantity) return;
      ['min', 'max', 'step'].forEach((attr) => {
        const value = mainQuantity.getAttribute(attr);
        if (value) stickyQuantity.setAttribute(attr, value);
        else stickyQuantity.removeAttribute(attr);
      });
      stickyQuantity.value = mainQuantity.value;
    };

    const updateMainQuantity = () => {
      if (!mainQuantity || !stickyQuantity) return;
      mainQuantity.value = stickyQuantity.value;
      mainQuantity.dispatchEvent(new Event('change', { bubbles: true }));
    };

    if (stickyQuantity && mainQuantity) {
      stickyQuantity.addEventListener('input', updateMainQuantity);
      stickyQuantity.addEventListener('change', updateMainQuantity);
      mainQuantity.addEventListener('change', () => {
        stickyQuantity.value = mainQuantity.value;
      });
      mainQuantity.addEventListener('input', () => {
        stickyQuantity.value = mainQuantity.value;
      });

      // Watch for programmatic value changes (e.g., variant change resets quantity)
      const quantityObserver = new MutationObserver(() => {
        if (stickyQuantity.value !== mainQuantity.value) {
          stickyQuantity.value = mainQuantity.value;
        }
      });
      quantityObserver.observe(mainQuantity, { attributes: true, attributeFilter: ['value'] });

      // Also poll for value changes since input.value changes don't trigger mutation
      let lastKnownValue = mainQuantity.value;
      setInterval(() => {
        if (mainQuantity.value !== lastKnownValue) {
          lastKnownValue = mainQuantity.value;
          stickyQuantity.value = mainQuantity.value;
        }
      }, 200);
    }

    if (stickyButton) {
      stickyButton.addEventListener('click', () => {
        updateMainQuantity();
        mainAddButton.click();
      });
    }

    void productForm;

    syncButton();
    syncQuantityAttributes();

    if (window.PUB_SUB_EVENTS && typeof window.subscribe === 'function') {
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, (event) => {
        if (event?.data?.sectionId !== sectionId) return;
        // Small delay to wait for DOM updates
        setTimeout(() => {
          syncButton();
          syncQuantityAttributes();
        }, 50);
      });
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          bar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(mainAddButton);
  };

  stickyBars.forEach(setupStickyBar);
});
